import fetchInvoices from '../../../Services/fetchInvoices'

export default () => (dispatch) => {

  dispatch(fetchInvoices())

}
